import $ from 'jquery';
import { func } from 'prop-types';
var CurrentTime = 0;
//import '../../Components/VideoPlayerComponent/vortexplayer/js/player_lib.js';




export function loadPlayer(t)
{
    try
    {
        if (t.state.hlsStartPosition == 0)
        {
            t.state.vortex = window.$("#" + t.state.id).vortexplayer({
                code: "d9b0c93f6b2a467ebbd939cc153484fd",
                width: t.state.vwidth,
                height: t.state.vheight,
                hide_controls: t.state.hide_controls,
                default_label: t.state.defaultlLbl,
                enable_download_video: t.state.enableDownload,
                use_additional_urls: t.state.usewebsocket,
                useSsl: t.state.isSocketSSL,
                additional_urls_tooltip: 'Options',
                additional_urls: [
                    {
                        title: t.state.malt_title,
                        type: t.state.malt_type,
                        url: t.state.malt_url,
                    }],
                skin_name: "default",
                auto_start: t.state.auto_start,
                enable_chromecast: t.state.enable_chromecast,
                loop: t.state.loop,
                volume: t.state.volume,
                intVolume: t.state.intVolume,
                //muted: t.state.muted,
                url: t.state.videoUrl,
                title: "",
                use_360_degree: t.state.is360Video,
                hide_controls: t.state.hide_controls,
                clickable: t.state.clickable,
                vortex360_options: {
                    clickAndDrag: true
                },
                captions: {
                    sources: [
                        {
                            src: t.state.CaptionSrc,
                            lang: "en",
                            label: "English",
                            src_default: "default"
                        }
                    ],
                    captions_side: "middle_bottom",
                    font_settings: {
                        color: "#FFFFFF",
                        background: "#000000",
                        align: "center",
                        opacity: "0.7"
                    }
                },
                onplay: t.state.onPlayVideoAction != undefined ? t.state.onPlayVideoAction : null,
                onpause: t.state.onPauseVideoAction != undefined ? t.state.onPauseVideoAction : null,
                use_vimeo: t.state.isVimeo,
                vimeo_options: {
                    video_id: t.state.VimeoVideoID
                },
                Adsources: t.state.Adsources,
                special_parameters: t.state.special_parameters,
            });
        }
        else
        {
            t.state.vortex = window.$("#" + t.state.id).vortexplayer({
                code: "d9b0c93f6b2a467ebbd939cc153484fd",
                width: t.state.vwidth,
                height: t.state.vheight,
                hide_controls: t.state.hide_controls,
                default_label: t.state.defaultlLbl,
                enable_download_video: t.state.enableDownload,
                use_additional_urls: t.state.usewebsocket,
                useSsl: t.state.isSocketSSL,
                additional_urls_tooltip: 'Options',
                additional_urls: [
                    {
                        title: t.state.malt_title,
                        type: t.state.malt_type,
                        url: t.state.malt_url,
                    }],
                skin_name: "default",
                auto_start: t.state.auto_start,
                enable_chromecast: t.state.enable_chromecast,
                loop: t.state.loop,
                volume: t.state.volume,
                intVolume: t.state.intVolume,
                //muted: t.state.muted,
                url: t.state.videoUrl,
                title: "",
                hlsStartPosition: t.state.hlsStartPosition,
                use_360_degree: t.state.is360Video,
                hide_controls: t.state.hide_controls,
                clickable: t.state.clickable,
                vortex360_options: {
                    clickAndDrag: true
                },
                captions: {
                    sources: [
                        {
                            src: t.state.CaptionSrc,
                            lang: "en",
                            label: "English",
                            src_default: "default"
                        }
                    ],
                    captions_side: "middle_bottom",
                    font_settings: {
                        color: "#FFFFFF",
                        background: "#000000",
                        align: "center",
                        opacity: "0.7"
                    }
                },
                onplay: t.state.onPlayVideoAction != undefined ? t.state.onPlayVideoAction : null,
                onpause: t.state.onPauseVideoAction != undefined ? t.state.onPauseVideoAction : null,
                use_vimeo: t.state.isVimeo,
                vimeo_options: {
                    video_id: t.state.VimeoVideoID
                },
                Adsources: t.state.Adsources,
                special_parameters: t.state.special_parameters,
            });
        }
        if (document.getElementById("player-button"))
        {
            document.getElementById("player-button").style.zIndex = 111;
        }
    }
    catch (ex)
    {
        alert(ex);
    }
}
export function changeUrl(t, VideoItem)
{
    try
    {
        //t.state.vortex.vortexplayer('loadUrl', url);
        t.setState({
            vortex: null, videoUrl: VideoItem.videoUrl, isVimeo: VideoItem.isVimeo,
            VimeoVideoID: VideoItem.VimeoVideoID
        }, () =>
        {
            loadPlayer(t)
        })
        console.log("change url = " + VideoItem.videoUrl)
    }
    catch (e)
    {
        console.log(e)
    }
}
export function changeVtt(t, CaptionSrc)
{
    try
    {

        //t.state.vortex.vortexplayer('loadUrl', url);
        t.setState({
            vortex: null,
            captions: {
                live_caption: false,
                sources: [
                    {
                        src: CaptionSrc,
                        lang: "en",
                        label: "English",
                        src_default: ""
                    }
                ],
                captions_side: "middle_bottom",
                font_settings: {
                    color: "#FFFFFF",
                    background: "#000000",
                    align: "center",
                    opacity: "0.7"
                }
            },
        }, () =>
        {
            loadPlayer(t)
        })
    }
    catch (e)
    {
        console.log(e)
    }
}
export function resizePlayer(t, width, height)
{
    try
    {
        let vor = t.state.vortex;
        vor.vortexplayer('resize', width, height);
    }
    catch (e)
    {
        console.log(e)
    }
}
export function playPlayer(t)
{
    try
    {
        let vor = t.state.vortex;
        vor.vortexplayer('play');
    }
    catch (e)
    {
        console.log(e)
    }
}
export function pausePlayer(t)
{
    try
    {
        let vor = t.state.vortex;
        vor.vortexplayer('pause');
    }
    catch (e)
    {
        console.log(e)
    }
}
export function stopPlayer(t)
{
    try
    {
        let vor = t.state.vortex;
        vor.vortexplayer('stop');
    }
    catch (e)
    {
        console.log(e)
    }
}
export function destroyPlayer(t)
{
    try
    {
        let vor = t.state.vortex;
        vor.vortexplayer('destroy');
    }
    catch (e)
    {
        console.log(e)
    }
}
export function seekPlayer(t, time)
{
    try
    {
        console.log("time = ", time);
        var x = getCurrentTime2(t);
        var duration = getVideoDuration(t);
        //var final_time = Math.ceil(x) + parseInt(time)
        var final_time = parseInt(time)
        if (final_time >= 0 && final_time <= duration)
        {
            let vor = t.state.vortex;
            vor.vortexplayer('seek', final_time + "");
        }
        else if (final_time < 0)
        {
            let vor = t.state.vortex;
            vor.vortexplayer('seek', "0");
        }
    }
    catch (e)
    {
        console.log(e)
    }
}
export function changeOffesstTime(t, time)
{
    try
    {
        t.state.vortex.find('.vortex_vod')[0].currentTime = time;
    }
    catch (e)
    {
        console.log(e)
    }
}
export function changeVolum(t, volume)
{
    try
    {
        t.setState({ volume: volume }, () =>
        {
            let vor = t.state.vortex.find('.vortex_vod')[0];
            vor.volume = volume;
        })

    }
    catch (e)
    {
        console.log(e)
    }
}
export function changeMute(t, mute, volume)
{
    try
    {
        let vor = t.state.vortex.find('.vortex_vod')[0];
        if (mute === true)
        {
            vor.muted = true;
            vor.volume = 0;
        }
        else
        {
            vor.muted = false;
            vor.volume = volume;
        }
    }
    catch (e)
    {
        console.log(e)
    }
}
export function changeMute2(t)
{
    try
    {
        var vortex = t.state.vortex;
        let vor = t.state.vortex.find('.vortex_vod')[0];

        var v_old = vor.muted;
        if (v_old === false)
        {
            vor.muted = true;
            vortex.vortexplayer('changeVolumIcon', 0)
        }
        else
        {
            vor.muted = false;
            vortex.vortexplayer('changeVolumIcon', parseInt((vor.volume * 100)))

        }
    }
    catch (e)
    {
        console.log(e)
    }
}

export function getCurrentTime(t)
{
    try
    {
        if (t.state.vortex && t.state.isVimeo == false)
        {
            var time = t.state.vortex.vortexplayer('videoCurrentTime');
            var s = time;
        }
    }
    catch {

    }
}
export function getCurrentTime2(t)
{
    try
    {
        var time = 0;
        if (t.state.vortex && t.state.isVimeo == false)
        {
            time = t.state.vortex.vortexplayer('videoCurrentTime');

        }
        return time;
    }
    catch (ex)
    {
        console.log("ex= ", ex)
    }
}
export function getVideoDuration(t)
{
    try
    {
        var time = 0;
        if (t.state.vortex && t.state.isVimeo == false)
        {
            time = t.state.vortex.vortexplayer('videoDuration');

        }
        return time;
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }
}

export function on_up_arrow_clicked(t)
{
    try
    {
        var vortex = t.state.vortex;
        let vor = vortex.find('.vortex_vod')[0];

        var v_old = vor.volume.toFixed(1);
        console.log("38:v_old", v_old)
        if (parseFloat(v_old) < 1)
        {
            var mute_old = vor.muted;
            if (mute_old === true)
            {
                vor.muted = false;
            }
            vor.volume = parseFloat(v_old) + 0.1;
        }
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }
}
export function on_down_arrow_clicked(t)
{
    try
    {
        var vortex = t.state.vortex;
        let vor = vortex.find('.vortex_vod')[0];
        var v_old = vor.volume.toFixed(1);
        console.log("40:v_old", v_old)
        if (v_old > 0)
        {
            var mute_old = vor.muted;
            if (mute_old === true)
            {
                vor.muted = false;
            }
            vor.volume = parseFloat(v_old) - 0.1;

        }
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }
}
export function on_left_arrow_clicked(t)
{
    try
    {
        var vortex = t.state.vortex;
        let vor = vortex.find('.vortex_vod')[0];

        var v_old = vor.currentTime;
        if (v_old > 0)
        {
            vor.currentTime = v_old - 5;
        }
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }
}
export function on_right_arrow_clicked(t)
{
    try
    {
        var vortex = t.state.vortex;
        let vor = vortex.find('.vortex_vod')[0];

        var v_old = vor.currentTime;
        console.log("duration= ", vor.duration)
        var v_douration = vor.duration;
        if (v_old < v_douration)
        {
            vor.currentTime = v_old + 5;
        }
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }
}
export function on_full_screen_clicked(t)
{
    try
    {
        var vortex = t.state.vortex;
        if (!document.fullscreenElement)
        {
            vortex.vortexplayer('doFullscreen')
        }
        else
        {
            if (document.exitFullscreen)
            {
                document.exitFullscreen();
                $("#" + t.state.id).focus()
            }
        }
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }

}
export function on_c_letter_clicked(t) // for caption amd loop playlist
{
    try
    {
        var vortex = t.state.vortex;
        var isPlaylist = vortex.vortexplayer('isPlaylist');
        if (isPlaylist === true)
        {
            vortex.vortexplayer('forward');
        }
        else
        {
            var x = document.getElementsByClassName("subtitles")[0].style.display;
            if (x == "block")
            {
                if (document.getElementById("subtitles-off") !== null)
                {
                    //$(".subtitles").hide();
                    document.getElementById("subtitles-off").click();
                }

            }
            else
            {
                if (document.getElementById("subtitles-en") !== null)
                {
                    //$(".subtitles").show();
                    document.getElementById("subtitles-en").click();
                }
                if (document.getElementById("subtitles-live") !== null)
                {
                    //$(".subtitles").hide();
                    document.getElementById("subtitles-live").click();
                }
            }
        }
    }
    catch (ex)
    {
        
        console.log("ex= ", ex)
    }
}
export function seek_player_by_key_code(t, keyCode)
{
    try
    {
        var vortex = t.state.vortex;
        let vor = vortex.find('.vortex_vod')[0];
        var duration = vor.duration;
        var percent = .1;
        if (keyCode === 50 || keyCode === 98) { percent = .2; }
        else if (keyCode === 51 || keyCode === 99) { percent = .3; }
        else if (keyCode === 52 || keyCode === 100) { percent = .4; }
        else if (keyCode === 53 || keyCode === 101) { percent = .5; }
        else if (keyCode === 54 || keyCode === 102) { percent = .6; }
        else if (keyCode === 55 || keyCode === 103) { percent = .7; }
        else if (keyCode === 56 || keyCode === 104) { percent = .8; }
        else if (keyCode === 57 || keyCode === 105) { percent = .9; }
        var new_time = (percent * duration);
        vor.currentTime = new_time;
    }
    catch (e)
    {
        console.log(e)
    }
}
//if (VimeoCurrentTime < VideoStartTime)
//{
//    vortex.vortexplayer('seek', VideoStartTime);
//}

//if (VimeoCurrentTime > VideoEndTime)
//{
//    vortex.vortexplayer("destroy");
//}